import Vue from 'vue'
import FirestoreCollectionStore from '../../../modules/vuex-firestore/FirestoreCollectionStore'
import { db } from '../../../modules/firebase/core'

const html_header ='\
<!DOCTYPE html>\
<html lang="ja">\
<head>\
<meta charset="UTF-8">\
</head>\
<body>'
const html_footer = '\
</body>\
</html>\
'

const state = {
  channels: {},
  updates: {}
}

const mutations = {
  // override
  _add(state, { key, data }) {
    const message = state.$formatter(data)
    const channel = message.channel ? message.channel : '*'
    if (!state.channels[channel]) Vue.set(state.channels, channel, [])
    state.channels[channel].push(Object.assign(message, { key }))

    // console.log(state);


    // updates
    const { timestamp } = message
    if (timestamp && timestamp.toMillis() > Date.now() - 30000) { // 30sec
      Vue.set(state.updates, channel, true)
    }

    Vue.set(state.items, key, message)
    if (state.indexies.indexOf(key) < 0) {
      state.indexies.push(key)
    }
  },
  // override
  _set(state, { key, data }) {
    const message = state.$formatter(data)
    // console.log(message);

    const channel = message.channel ? message.channel : '*'
    const { timestamp } = message
    if (timestamp && timestamp.toMillis() > Date.now() - 30000) { // 30sec
      Vue.set(state.updates, channel, true)
    }
    Object.assign(state.items[key], message)
  },
  read(state, channel) {
    state.updates[channel] = false
  }
}

const getters = {
  getChannelMessages: state => channel => {
    return state.channels[channel] || []
  },
  updates() {
    return state.updates
  }
}

const actions = {
  log({ dispatch }, text) {
    if (process.env.NODE_ENV === 'development') return;
    dispatch('$create', {
      from: null,
      to: null,
      channel: 'sys',
      text: `${text}`,
      extend: {}
    })
  },
  toTextData({ state, rootGetters }) {
    return state.indexies.reduce((res, key) => {
      const item = state.items[key]
      const toCharacterKeys = Array.isArray(item.to) ? item.to : []
      const character = rootGetters['characters/$get'](item.from)
      const toCharacter = toCharacterKeys.map(cKey => rootGetters['characters/$get'](cKey).name)
      if (character) {
        res += character.name
      }
      if (toCharacter.length !== 0) {
        res += ' > ' + toCharacter.join('＆')
      }
      res += ': '
      if (item.secret) {
        res += '[Secret Dice]'
      }
      res += item.text
      res += ' '
      if (item.extend.calc) {
        res += '(' + item.extend.calc.dice.map(dice => {
          return dice.role
        }).join(',') + ')'
        if (item.extend.calc.result === true) {
          res += '[成功]'
        } else if (item.extend.calc.result === false) {
          res += '[失敗]'
        }
      }
      res += '\n'
      return res
    }, '')
  },
  toHTMLData({ state, rootGetters }) {
    const html_content = state.indexies.reduce((res, key) => {
      const item = state.items[key]
      const character = rootGetters['characters/$get'](item.from)
      const toCharacterKeys = Array.isArray(item.to) ? item.to : []
      const toCharacter = toCharacterKeys.map(cKey => rootGetters['characters/$get'](cKey).name)
      res += '<div style="font-family: sans-serif;">'
      res += '<p style="font-size: 14px;">'
      res += '<span style="font-weight: bold;">'
      if (character) {
        res += character.name
      }
      if (toCharacter.length !== 0) {
        res += ' > ' + toCharacter.join('＆')
      }
      res += ': </span>'
      if (item.secret) {
        res += '[Secret Dice]'
      }
      res += item.text
      if (item.extend.calc) {
        res += '<span style="color: gray; margin-left: 4px;">'
        res += '(' + item.extend.calc.dice.map(dice => {
          return dice.role
        }).join(',') + ')'
        if (item.extend.calc.result === true) {
          res += '[成功]'
        } else if (item.extend.calc.result === false) {
          res += '[失敗]'
        }
        res += '</span>'
      }
      res += '</p>'
      res += '</div>'
      return res
    }, '')
    return html_header + html_content + html_footer
  },
  toMainTextData({ state, rootGetters }) {
    return state.indexies.reduce((res, key) => {
      const item = state.items[key]
      if (item.channel === '*' || !item.channel) {
        const toCharacterKeys = Array.isArray(item.to) ? item.to : []
        const character = rootGetters['characters/$get'](item.from)
        const toCharacter = toCharacterKeys.map(cKey => rootGetters['characters/$get'](cKey).name)
        if (character) {
          res += character.name
        }
        if (toCharacter.length !== 0) {
          res += ' > ' + toCharacter.join('＆')
        }
        res += ': '
        if (item.secret) {
          res += '[Secret Dice]'
        }
        res += item.text
        res += ' '
        if (item.extend.calc) {
          res += '(' + item.extend.calc.dice.map(dice => {
            return dice.role
          }).join(',') + ')'
          if (item.extend.calc.result === true) {
            res += '[成功]'
          } else if (item.extend.calc.result === false) {
            res += '[失敗]'
          }
        }
        res += '\n'
      }
      return res
    }, '')
  },
  toMainHTMLData({ state, rootGetters }) {
    const html_content = state.indexies.reduce((res, key) => {
      const item = state.items[key]
      if (item.channel === '*' || !item.channel) {
        const character = rootGetters['characters/$get'](item.from)
        const toCharacterKeys = Array.isArray(item.to) ? item.to : []
        const toCharacter = toCharacterKeys.map(cKey => rootGetters['characters/$get'](cKey).name)
        res += '<div style="font-family: sans-serif;">'
        res += '<p style="font-size: 14px;">'
        res += '<span style="font-weight: bold;">'
        if (character) {
          res += character.name
        }
        if (toCharacter.length !== 0) {
          res += ' > ' + toCharacter.join('＆')
        }
        res += ': </span>'
        if (item.secret) {
          res += '[Secret Dice]'
        }
        res += item.text
        if (item.extend.calc) {
          res += '<span style="color: gray;">'
          res += '(' + item.extend.calc.dice.map(dice => {
            return dice.role
          }).join(',') + ')'
          if (item.extend.calc.result === true) {
            res += '[成功]'
          } else if (item.extend.calc.result === false) {
            res += '[失敗]'
          }
          res += '</span>'
        }
        res += '</p>'
        res += '</div>'
      }
      return res
    }, '')
    return html_header + html_content + html_footer
  },
  async $removeAll({ state, commit }) {
    const indexies = state.indexies.concat([])
    while (indexies.length > 0) {
      const t = indexies.splice(-500)
      const batch = db.batch()
      t.forEach((key) => {
        batch.delete(state.$collection.doc(key))
      })
      await batch.commit()
    }
    state.channels = {}
    state.updates = {}
    commit('$checkout', null)
  }
}

function formatter(d) {
  return d
}

export default new FirestoreCollectionStore({
  $name: 'messages',
  $formatter: formatter,
  state,
  mutations,
  getters,
  actions
})
